import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { fetchReport } from '../../../api/reportApi.js';
import type { ReportFilters, ReportResponse } from '../../../types/report.js';

export const REPORT_QUERY_KEY = 'report';

export const useReportQuery = (filters?: ReportFilters) =>
  useQuery<ReportResponse, Error>({
    queryKey: filters ? [REPORT_QUERY_KEY, filters] : [REPORT_QUERY_KEY, 'idle'],
    queryFn: ({ signal }) => {
      if (!filters) {
        throw new Error('Filters missing');
      }
      return fetchReport(filters, { signal });
    },
    enabled: Boolean(filters),
    placeholderData: keepPreviousData,
  });
